import router from './router'
import store from './store'
export default {
  router,
  store,
  storeName: 'TEAMANALYTICS'
}
